module.exports = __webpack_public_path__ + "img/evaluation-2014-award.cea9cebc.jpg";